<template>
  <div class="Invest">
    <h3 class="mb-3 text-right">Invertir</h3>
    <b-card class="mb-3">
      <b-card-text>
        <b-container>
          <b-row align-v="center">
            <b-col lg="1" md="2" sm="2" cols="4">
              <div
                :class="color"
                class="pt-3 pb-3 text-center text-font-white"
                style="border-radius: 100px; font-size: 20px"
              >
                1
              </div>
            </b-col>
            <b-col lg="3" md="2" sm="2" cols="8">
              <div class="text-font-black" style="font-size: 18px">
                Seguridad
              </div>
            </b-col>
            <b-col lg="1" md="2" sm="2" cols="4">
              <div
                :class="color1"
                class="pt-3 pb-3 text-center text-font-white colorStep"
                style="border-radius: 100px; font-size: 20px"
              >
                2
              </div>
            </b-col>
            <b-col lg="3" md="2" sm="2" cols="8">
              <div class="text-font-black" style="font-size: 18px">Monto</div>
            </b-col>
            <b-col lg="1" md="2" sm="2" cols="4">
              <div
                :class="color2"
                class="pt-3 pb-3 text-center text-font-white"
                style="border-radius: 100px; font-size: 20px"
              >
                3
              </div>
            </b-col>
            <b-col lg="3" md="2" sm="2" cols="8">
              <div class="text-font-black" style="font-size: 18px">
                Confirmar


              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-card-text>
    </b-card>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
      v-if="next == 1"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">
              2FA - Autenticación de dos factores
            </div>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-list-group>
          <div class="text-center text-font-black mb-3" style="font-size: 20px">
            Ingresa el código de la aplicación de autenticación que
            está asociada a tu cuenta.
          </div>
          <b-container>
            <b-row align-h="center">
              <b-col lg="6">
                <b-form-input
                  v-model="code"
                  placeholder=""
                  type="number"
                  size="sm"
                  class="shadow-sm bg-white rounded"
                ></b-form-input>
              </b-col>
            </b-row>
            <p class="text-font-black">
              Agregar el código de 6 dígitos que proporciona Google
              Authenticator
            </p>
            <br />

            <b-row align-h="center" class="">
              <b-col>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="btn-card-color pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  v-if="!progress"
                  @click="step1()"
                  :disabled="checkAuth"
                >
                  <span class="text-font-white" style="font-size: 18px">Continuar</span>
                </b-button>
                <div v-if="progress" class="text-center text-primary">
                  <b-spinner small class="align-middle"></b-spinner>
                  <strong class="ml-2">Cargando...</strong>
                </div>
              </b-col>
            </b-row>
            <div class="text-light-black mt-3">
              Si perdiste tu código 2FA escribenos a nuestro chat de ayuda o nuestro<br />
             WhatsApp <a target="_blank" href="https://wa.me/message/GLVP4YY6UUQ4M1">presionando aquí</a>  y te contactaremos para que recuperes
              tu cuenta.
            </div>
            <router-link :to="{ name: 'Chat'}">
              <div class="text-light-black mt-3">
              Chat de ayuda
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="card-color p-1 rounded-circle"
                height="30px"
                viewBox="0 0 24 24"
                width="30px"
                fill="#FFFFFF"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
                />
              </svg>
            </div>
            </router-link>
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
      v-if="next == 2"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">
              Indica el monto que deseas invertir
            </div>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-list-group>
          <b-container>
            <b-row>
              <b-col>
                <div
                  class="text-left text-font-black mb-2"
                  style="font-size: 15px"
                >Cambiaremos por “Los depósitos para colocaciones se recibirán en un lapso de 5 días antes de la colocación aceptada.
                </div>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col v-if="account">
                <div class="text-font-black text-left">Principal</div>
                <b-list-group class="p-2">
                  <b-list-group-item
                    class="flex-column align-items-start"
                    style="border-radius: 15px; border-color: #121419"
                  >
                    <b-row align-v="center" align-h="start">
                      <b-col md="3 ">
                        <img
                          src="../assets/LogoSSBG.png"
                          height="50px"
                          alt=""
                        />
                      </b-col>
                      <b-col md="6" v-if="account">
                        <h5 class="mb-1 text-font-black text-left">
                          {{ account.name }}
                        </h5>
                        <p class="mb-1 text-light-black text-left">
                          <strong>Creado el {{ account.created_at }}</strong>
                        </p>
                      </b-col>
                      <b-col md="3">
                        <p class="mb-1 text-light-black text-center">Saldo</p>
                        <h5
                          class="mb-1 text-font-black text-center"
                          style="font-size: 20px"
                        >
                          $ {{ total_balance }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col lg="5" md="7">
                <div
                  style="font-size: 24px"
                  class="text-light-black-title mt-2"
                >
                  Monto a depositar
                </div>
                <b-form-input
                  v-model="invest"
                  placeholder=""
                  type="number"
                  size="sm"
                  class="shadow-sm bg-white rounded"
                ></b-form-input>
              </b-col>
            </b-row>
            <!-- <b-row align-h="center" class="mt-3">
              <b-col lg="3" md="6" sm="6">
                <div class="text-font-black">Small Cap / Minor Investors:</div>
                <div




                
                  style="
                    font-weigth: lighter;
                    font-family: Montserrat;
                    font-size: 15px;
                  "
                >
                  Colocación mínima <span class="text-light-black">$100</span>
                </div>
              </b-col>
              <b-col lg="3" md="6" sm="6">
                <div class="text-font-black">Big account:</div>
                <div
                  style="
                    font-weigth: lighter;
                    font-family: Montserrat;
                    font-size: 15px;
                  "
                >
                  Colocación mínima <span class="text-light-black">$5000</span>
                </div>
              </b-col>
            </b-row> -->
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              class="mt-5"
              unchecked-value="not_accepted"
            >
              <span class="text-font-black"
                >He leído y acepto los términos y condiciones de invertir con
                BRIGDE BONDS & ASSOCIATES</span
              >
            </b-form-checkbox>
            <b-row align-h="center" class="mt-5">
              <b-col>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="mr-3 pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  @click="
                    code = '';
                    next--;
                  "
                >
                  <span class="text-font-white" style="font-size: 18px">Cancelar</span>
                </b-button>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="btn-card-color pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  @click="step2"
                  :disabled="check"
                >
                  <span class="text-font-white" style="font-size: 18px">Continuar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
      v-if="next == 3"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">Realizar el pago</div>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-list-group>
          <b-container>
            <b-row align-h="center" align-v="center" class="mb-2">
              <b-col>
                <div
                  class="text-center text-font-black"
                  style="font-size: 20px"
                >
                  Cliente Bridge Bonds
                </div>
                <h5
                  class="mb-1"
                  style="
                    color: black;
                    font-size: 20px;
                    font-family: Montserrat;
                    font-weigth: medium;
                  "
                >
                  {{ type_invest_account == 1 ? "Small Cap" : "Big Account" }}
                </h5>
              </b-col>
              <b-col>
                <div class="text-center text-font-black mb-3">
                  Monto a depositar
                </div>
                <h5 class="mb-1 text-light-black" style="font-size: 36px">
                  $ {{ invest }}
                </h5>
              </b-col>
              <b-col>
                <div class="text-center text-font-black mb-1">
                  Balance mensual
                </div>
                <h5 class="mb-1 text-font-black" style="font-size: 12px">
                  Riesgo de la Colocación:
                  {{ type_invest_account == 1 ? "5 %" : "2 %" }}
                </h5>
                <h5 class="mb-1 text-font-black" style="font-size: 12px">
                  Beneficio de la Colocación:
                  {{ type_invest_account == 1 ? "1 - 15 %" : "1 - 8 %" }}
                </h5>
              </b-col>
            </b-row>
            <b-row align-h="center">
              <b-col v-if="account">
                <div class="text-font-black text-left">Principal</div>
                <b-list-group class="p-2">
                  <b-list-group-item
                    class="flex-column align-items-start"
                    style="border-radius: 15px; border-color: #121419"
                  >
                    <b-row align-v="center" align-h="start">
                      <b-col md="3 ">
                        <img
                          src="../assets/LogoSSBG.png"
                          height="50px"
                          alt=""
                        />
                      </b-col>
                      <b-col md="6" v-if="account">
                        <h5 class="mb-1 text-font-black text-left">
                          {{ account.name }}
                        </h5>
                        <p class="mb-1 text-light-black text-left">
                          <strong>Creado el {{ account.created_at }}</strong>
                        </p>
                      </b-col>
                      <b-col md="3">
                        <p class="mb-1 text-light-black text-center">Saldo</p>
                        <h5
                          class="mb-1 text-font-black text-center"
                          style="font-size: 20px"
                        >
                          $ {{ total_balance }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <b-row align-h="center" class="mt-5">
              <b-col>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="mr-3 pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  @click="next--"
                >
                  <span class="text-font-white" style="font-size: 18px">Regresar</span>
                </b-button>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="btn-card-color pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  v-if="!progress"
                  @click="step3"
                >
                  <span class="text-font-white" style="font-size: 18px">Continuar</span>
                </b-button>
                <div v-if="progress" class="text-center text-primary">
                  <b-spinner small class="align-middle"></b-spinner>
                  <strong class="ml-2">Cargando...</strong>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
    <b-modal
      id="modal-nomoney"
      ref="modal"
      title-class="text-font-black"
      title="Saldo insuficiente"
      hide-footer
      size="xl"
    >
      <b-container>
        <b-row align-v="center" align-h="center">
          <b-col lg="12">
            <p
            class="text-center"
              style="
                
                font-size: 20px;
                font-family: Montserrat;
                font-weigth: medium;
              "
            >
              Tu saldo disponible es inferior al monto que deseas invertir
              ¿Te gustaria ingresar dinero a tu cuenta?
            </p>
            
          </b-col>
          <b-col v-if="account" lg="12">
                <div class="text-font-black text-left">Principal</div>
                <b-list-group class="p-2">
                  <b-list-group-item
                    class="flex-column align-items-start"
                    style="border-radius: 15px; border-color: #121419"
                  >
                    <b-row align-v="center" align-h="start">
                      <b-col md="3 ">
                        <img
                          src="../assets/LogoSSBG.png"
                          height="50px"
                          alt=""
                        />
                      </b-col>
                      <b-col md="6" v-if="account">
                        <h5 class="mb-1 text-font-black text-left">
                          {{ account.name }}
                        </h5>
                        <p class="mb-1 text-light-black text-left">
                          <strong>Creado el {{ account.created_at }}</strong>
                        </p>
                      </b-col>
                      <b-col md="3">
                        <p class="mb-1 text-light-black text-center">Saldo</p>
                        <h5
                          class="mb-1 text-font-black text-center"
                          style="font-size: 20px; color: red"
                        >
                          $ {{ total_balance }}
                        </h5>
                      </b-col>
                      
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col lg="12" class="mb-5">
                <div style="font-size: 24px"
                  class="text-light-black-title mt-2 text-center">
                  Monto a depositar
                </div>
                <h5 class="mb-1 text-light-black text-center" style="font-size: 24px">
                  $ {{ invest }}
                </h5>
              </b-col>
              
          <b-col lg="12">
            <b-row align-h="around">
              <b-col lg="2" sm="6">
                <b-button
              style="border-radius: 15px; border: none;"
              class="pl-5 pr-5 pb-2 pt-2 center"
              size="sm"
              @click="
                closeModal();
              "
            >
              <span class="text-font-white" style="font-size: 18px">Cancelar</span>
            </b-button>
              </b-col>
              <b-col lg="2" sm="6">
                <b-button
              style="border-radius: 15px; border: none"
              class="btn-card-color pl-5 pr-5 pb-2 pt-2"
              size="sm"
              :to="{ name: 'PaymentReport'}"
            >
              <span class="text-font-white" style="font-size: 18px">Aceptar</span>
            </b-button>
              </b-col>
            </b-row>            
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { mapActions, mapState } from "vuex";

export default {
  name: "Invest",
  data() {
    return {
      id_user: Cookies.get("id"),
      id_account: null,
      type_invest_account: null,
      loadaccount: true,
      total_balance: null,
      code: "",
      invest: null,
      description: "",
      status: "not-accepted",
      next: 1,
      factor: Cookies.get("factor"),
      progress: false,
      account: [
        {
          overview: {
            balance: 0,
          },
        },
      ],
    };
  },
  methods: {
    ...mapActions(["Verify2FA", "getAccount", "CreateInvest"]),
    closeModal(){
       this.$nextTick(() => {
          this.$bvModal.hide("modal-nomoney");
        });
    },
    AllAccount() {
      console.log(this.id_user);
      this.getAccount(this.id_user)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.loadaccount = false;
            this.account = response.data[0];
            this.id_account = response.data[0].id;
            this.total_balance = response.data[0].overview.balance;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    step1() {
      this.progress = true;
      console.log(this.code);
      let form = {
        google_code: this.code,
      };
      this.Verify2FA(form)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.next++;
            this.progress = false;
          } else {
            this.progress = false;

            Swal.fire({
              title: "Error",
              text: "No es el código correcto",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.progress = false;

          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Intente más tarde",
            icon: "error",
          });
        });
    },
    step2() {
      if (this.id_account == null) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar una cuenta",
          icon: "warning",
        });
      } else if (this.invest == "" || this.invest == null) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un monto",
          icon: "warning",
        });
      } else if (this.invest < 100) {
        Swal.fire({
          title: "¡Atención!",
          text: "El monto debe ser mayor a $100",
          icon: "warning",
        });
      } else if (this.invest > this.total_balance) {
        this.$nextTick(() => {
          this.$bvModal.show("modal-nomoney");
        });
      } else if (this.invest >= 100 && this.invest < 5000) {
        this.type_invest_account = 1;
        console.log(this.invest);
        console.log(this.status);
        this.next++;
      } else if (this.invest >= 5000) {
        this.type_invest_account = 0;
        console.log(this.invest);
        console.log(this.status);
        this.next++;
      }
    },
    step3() {
      Swal.fire({
        title: "¡Atención!",
        text:
          "¿Está seguro que desea hacer una Colocación de $" + this.invest + "?",
        icon: "question",
      }).then((result) => {
        if (result.isConfirmed) {
          this.progress = true;

          let form = {
            amount: this.invest,
          };
          this.CreateInvest(form)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                this.progress = false;
                Swal.fire({
                  title: "Listo",
                  text: "Su Colocación ha sido realizada con éxito",
                  icon: "success",
                  showConfirmButton: false,
                timer: 1500,
                })
                this.$router.push("/home");
              } else {
                this.progress = false;

                Swal.fire({
                  title: "Error",
                  text: "No se pudo realizar su Colocación",
                  icon: "error",
                });
              }
            })
            .catch((error) => {
              this.progress = false;

              console.log(error);
              Swal.fire({
                title: "Error",
                text: "Intente más tarde",
                icon: "error",
              });
            });
        }
      });
    },
  },
  computed: {
    ...mapState({
      me_user: (state) => state.me_user,
    }),
    color() {
      return {
        colorStep: this.next == 1,
        "bg-dark": this.next != 1,
      };
    },
    color1() {
      return {
        colorStep: this.next == 2,
        "bg-dark": this.next != 2,
      };
    },
    color2() {
      return {
        colorStep: this.next == 3,
        "bg-dark": this.next != 3,
      };
    },
    check() {
      return this.status == "accepted" ? false : true;
    },
    checkAuth() {
      return this.code.length == 6 ? false : true;
    },
  },
  mounted() {
    this.AllAccount();
    if (this.factor == 0) {
      this.next = 2
    } 
    
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
.colorStep {
  background-color: #121419;
}
</style>